import { FC } from 'react'
import { useWebsiteDataMock } from '@app/data/external/website/websites-mock'
import { AppContext, GqlProps } from './website'

// skip fetching the website query
const WebsiteProviderComponentMock: FC<GqlProps> = ({ children }) => {
  const state = useWebsiteDataMock()

  return (
    <AppContext.Provider value={state as any}>{children}</AppContext.Provider>
  )
}

export { WebsiteProviderComponentMock }
